const Flame = ({ iconColorProp, fillColorProp }) => {
	const iconColor = iconColorProp || '#4B4B4B';
	const fillColor = fillColorProp || 'none';

	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill={fillColor}
			stroke={iconColor}
			strokeWidth='2'
			strokeLinecap='round'
			strokeLinejoin='round'
		>
			<path d='M12 3q1 4 4 6.5t3 5.5a1 1 0 0 1-14 0 5 5 0 0 1 1-3 1 1 0 0 0 5 0c0-2-1.5-3-1.5-5q0-2 2.5-4' />
		</svg>
	);
};

export default Flame;
